<div class="movement-manager-search-item-container">

  <div align="end">

    <button mat-mini-fab color="warn" (click)="close()">

      <mat-icon>close</mat-icon>

    </button>

  </div>

  <h1 mat-dialog-title>{{ 'search.item' | translate }}</h1>

  <div mat-dialog-content>

    <app-item-search
      [configuration]="itemSelectionConfiguration"
      (onSelected)="onSelect($event)"></app-item-search>

  </div>

</div>
